export default "__VITE_ASSET__BuNhGWi0__"